var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_message-text",
    "data-name": "vuesax/outline/message-text",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#707070",
    width: 15.482,
    height: 15.482,
    viewBox: "0 0 15.482 15.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.935,13.908a1.461,1.461,0,0,1-1.161-.619L4.806,12a.3.3,0,0,0-.129-.065H4.354C1.664,11.934,0,11.205,0,7.58V4.354C0,1.5,1.5,0,4.354,0H9.515c2.851,0,4.354,1.5,4.354,4.354V7.58c0,2.851-1.5,4.354-4.354,4.354H9.192A.168.168,0,0,0,9.063,12L8.1,13.289A1.461,1.461,0,0,1,6.935,13.908ZM4.354.968C2.045.968.968,2.045.968,4.354V7.58c0,2.916,1,3.387,3.387,3.387h.323a1.21,1.21,0,0,1,.9.452l.968,1.29a.448.448,0,0,0,.774,0l.968-1.29a1.13,1.13,0,0,1,.9-.452h.323c2.309,0,3.387-1.077,3.387-3.387V4.354C12.9,2.045,11.824.968,9.515.968Z",
    transform: "translate(0.806 0.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H15.482V15.482H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6.935.968H.484A.487.487,0,0,1,0,.484.487.487,0,0,1,.484,0H6.935a.487.487,0,0,1,.484.484A.487.487,0,0,1,6.935.968Z",
    transform: "translate(4.032 4.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M4.354.968H.484A.487.487,0,0,1,0,.484.487.487,0,0,1,.484,0h3.87a.487.487,0,0,1,.484.484A.487.487,0,0,1,4.354.968Z",
    transform: "translate(4.032 7.902)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.a5a721e2214c2ce72295b5abe5b0f4a5.svg";
export { ForwardRef as ReactComponent };